import { render } from "./app_settings.vue?vue&type=template&id=40aa244e&scoped=true"
import script from "./app_settings.vue?vue&type=script&lang=js"
export * from "./app_settings.vue?vue&type=script&lang=js"

import "./app_settings.vue?vue&type=style&index=0&id=40aa244e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40aa244e"]])

export default __exports__